import React, {useEffect, useState} from 'react'
import { ContentContainer, Input, InputContainer, ChartContainer, RowForm, Label, ModelSIS, ModelSIR, ModelSEIRD, Modelchoice, InputRadioButton, ModelText} from './ZombieElements'
import {Line} from "react-chartjs-2";
import {InputLimitAndEmptyValueHandling} from "../../scripts/InputHandling";

const Zombie = () => {
    const [inputsSIS, setInputsSIS] = useState({N: 10000, NI: 100, t: 30, lambda: 0.7, mi: 0.1, gamma: 0.1});
    const [inputsSIR, setInputsSIR] = useState({N: 10000, NI: 10, t: 60, lambda: 0.6, gamma: 0.1});
    const [inputsSEIRD, setInputsSEIRD] = useState({N: 10000, NE: 100, t: 110, beta: 0.8, sigma: 0.6, gamma: 0.15, delta: 0.1});
    const [simSIS, setSimSIS] = useState([{}]);
    const [simSIR, setSimSIR] = useState([{}]);
    const [simSEIRD, setSimSEIRD] = useState([{}]);
    const [ModelChoice, setModelChoice] = useState('SIS');

    const InputsLimitSIS = [
        {
            InputName: "N",
            LimitMax: 10000000000,
            LimitMin: 1,
            default: 10000
        },
        {
            InputName: "NI",
            LimitMax: 10000000000,
            LimitMin: 1,
            default: 100
        },
        {
            InputName: "t",
            LimitMax: null,
            LimitMin: 1,
            default: 30
        },
        {
            InputName: "lambda",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.7
        },
        {
            InputName: "mi",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.1
        },
        {
            InputName: "gamma",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.1
        }];
    const InputsLimitSIR = [
        {
            InputName: "N",
            LimitMax: 10000000000,
            LimitMin: 1,
            default: 10000
        },
        {
            InputName: "NI",
            LimitMax: 10000000000,
            LimitMin: 1,
            default: 10
        },
        {
            InputName: "t",
            LimitMax: null,
            LimitMin: 1,
            default: 30
        },
        {
            InputName: "lambda",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.7
        },
        {
            InputName: "gamma",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.1
        }];
    const InputsLimitSEIRD = [
        {
            InputName: "N",
            LimitMax: 10000000000,
            LimitMin: 1,
            default: 10000
        },
        {
            InputName: "NE",
            LimitMax: 10000000000,
            LimitMin: 1,
            default: 100
        },
        {
            InputName: "t",
            LimitMax: null,
            LimitMin: 1,
            default: 110
        },
        {
            InputName: "beta",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.8
        },
        {
            InputName: "sigma",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.6
        },
        {
            InputName: "gamma",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.15
        },
        {
            InputName: "delta",
            LimitMax: 1,
            LimitMin: 0,
            default: 0.1
        }];

    const SIS = (N, NI, t, lambda, mi, gamma) => {
        const dt = 0.01;
        let zdrowi = N - NI;
        let chorzy = NI;
        let propChorzy = chorzy / N;
        const out = [{
            day: 0,
            resZdrowi: zdrowi,
            resChorzy: chorzy,
        }];

        for (let i = 1; i <= t; i++) {
            let time = 0;
            while (time < 1) {
                const dPropChorzy = (-lambda * (propChorzy ** 2) + ((lambda - (mi + gamma)) * propChorzy)) * dt;

                propChorzy += dPropChorzy;

                time += dt;
            }
            chorzy = Math.round(propChorzy * N);
            zdrowi = N - chorzy;
            out.push({
                day: i,
                resZdrowi: zdrowi,
                resChorzy: chorzy,
            });
        }
        return out;
    }

    const SIR = (N, NI, t, lambda, gamma) => {
        const dt = 0.01;
        let zdrowi = N - NI;
        let chorzy = NI;
        let odporni = 0;
        let propChorzy = chorzy / N;
        let propZdrowi = 1 - propChorzy;
        const out = [{
            day: 0,
            resZdrowi: zdrowi,
            resChorzy: chorzy,
            resOdporni: odporni,
        }];

        for (let i = 1; i <= t; i++) {
            let time = 0;
            while (time < 1) {
                const dPropZdrowi = (-lambda * propZdrowi * propChorzy) * dt;
                const dPropChorzy = ((lambda * propZdrowi * propChorzy) - (gamma * propChorzy)) * dt;

                propZdrowi += dPropZdrowi;
                propChorzy += dPropChorzy;

                time += dt;
            }
            zdrowi = Math.round(propZdrowi * N);
            chorzy = Math.round(propChorzy * N);
            odporni = N - zdrowi - chorzy;

            out.push({
                day: i,
                resZdrowi: zdrowi,
                resChorzy: chorzy,
                resOdporni: odporni,
            });
        }
        return out;
    }

    const SEIRD = (N, NE, t, beta, sigma, gamma, delta) => {
        const dt = 0.01;
        let zdrowi = N - NE;
        let zakazeni = NE;
        let chorzy = 0;
        let odporni = 0;
        let martwi = 0;
        let propZakazeni = NE / N;
        let propZdrowi = 1 - propZakazeni;
        let propChorzy = 0;
        let propOdporni = 0;
        let PropMartwi = 0;
        const out = [{
            day: 0,
            resZdrowi: zdrowi,
            resZakazeni: zakazeni,
            resChorzy: chorzy,
            resOdporni: odporni,
            resMartwi: martwi,
        }];

        for (let i = 1; i <= t; i++) {
            let time = 0;
            while (time < 1) {
                const dPropZakazeni = beta * propZdrowi * propChorzy * dt;
                const dPropChorzy = sigma * propZakazeni * dt;
                const dPropOdporni = gamma * propChorzy * dt;
                const dPropMartwi = delta * propChorzy * dt;

                propZdrowi -= dPropZakazeni;
                propZakazeni = propZakazeni + dPropZakazeni -dPropChorzy;
                propChorzy = propChorzy + dPropChorzy - dPropOdporni - dPropMartwi;
                propOdporni += dPropOdporni;
                PropMartwi += dPropMartwi;

                time += dt;
            }
            zdrowi = Math.round(propZdrowi*N);
            zakazeni = Math.round(propZakazeni*N);
            chorzy = Math.round(propChorzy*N);
            odporni = Math.round(propOdporni*N);
            martwi = Math.round(PropMartwi*N);

            out.push({
                day: i,
                resZdrowi: zdrowi,
                resZakazeni: zakazeni,
                resChorzy: chorzy,
                resOdporni: odporni,
                resMartwi: martwi,
            });
        }
        return out;
    }

    const handleOutFocus = (e) => {
        console.log(e.target.getAttribute('model'))
        switch(e.target.getAttribute('model')) {
            case 'SIS':
                const properValueSIS = InputLimitAndEmptyValueHandling(InputsLimitSIS, e)
                setInputsSIS({...inputsSIS, [e.target.name]: properValueSIS});
                e.target.value = properValueSIS;
                break;
            case 'SIR':
                const properValueSIR = InputLimitAndEmptyValueHandling(InputsLimitSIR, e)
                setInputsSIR({...inputsSIR, [e.target.name]: properValueSIR});
                e.target.value = properValueSIR;
                break;
            case 'SEIRD':
                const properValueSEIRD = InputLimitAndEmptyValueHandling(InputsLimitSEIRD, e)
                setInputsSEIRD({...inputsSEIRD, [e.target.name]: properValueSEIRD});
                e.target.value = properValueSEIRD;
                break;
            default:
                break;
        }
    }

    const handleChange = (e) => {
        setModelChoice(e.target.value);
    }

    useEffect(()=>{
        setSimSIS(SIS(inputsSIS.N, inputsSIS.NI, inputsSIS.t, inputsSIS.lambda, inputsSIS.mi, inputsSIS.gamma));
    }, [inputsSIS]);

    useEffect(()=>{
        setSimSIR(SIR(inputsSIR.N, inputsSIR.NI, inputsSIR.t, inputsSIR.lambda, inputsSIR.gamma));
    }, [inputsSIR]);

    useEffect(()=>{
        setSimSEIRD(SEIRD(inputsSEIRD.N, inputsSEIRD.NE, inputsSEIRD.t, inputsSEIRD.beta, inputsSEIRD.sigma, inputsSEIRD.gamma, inputsSEIRD.delta));
    }, [inputsSEIRD]);
    let dataSIS = {
        labels: Array.from(simSIS.map(s => s.day), (value, index) => (value===0) ? "Punkt startowy" : value),  // Etykiety osi X
        datasets: [
            {
                label: 'Zdrowi',  // Legenda
                data: simSIS.map(s => s.resZdrowi),  // Dane osi Y
                borderColor: 'rgba(75,192,91, 1)',  // Kolor linii
                backgroundColor: 'rgba(75,192,91, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
            {
                label: 'Chorzy',  // Legenda
                data: simSIS.map(s => s.resChorzy),  // Dane osi Y
                borderColor: 'rgb(192,75,75)',  // Kolor linii
                backgroundColor: 'rgba(192,75,75, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
        ],
    };
    let dataSIR = {
        labels: Array.from(simSIR.map(s => s.day), (value, index) => (value===0) ? "Punkt startowy" : value),  // Etykiety osi X
        datasets: [
            {
                label: 'Zdrowi',  // Legenda
                data: simSIR.map(s => s.resZdrowi),  // Dane osi Y
                borderColor: 'rgba(75,192,91, 1)',  // Kolor linii
                backgroundColor: 'rgba(75,192,91, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
            {
                label: 'Chorzy',  // Legenda
                data: simSIR.map(s => s.resChorzy),  // Dane osi Y
                borderColor: 'rgb(192,75,75)',  // Kolor linii
                backgroundColor: 'rgba(192,75,75, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
            {
                label: 'Odporni',  // Legenda
                data: simSIR.map(s => s.resOdporni),  // Dane osi Y
                borderColor: 'rgb(75, 192, 192)',  // Kolor linii
                backgroundColor: 'rgba(75, 192, 192, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
        ],
    };
    let dataSEIRD = {
        labels: Array.from(simSEIRD.map(s => s.day), (value, index) => (value===0) ? "Punkt startowy" : value),  // Etykiety osi X
        datasets: [
            {
                label: 'Zdrowi',  // Legenda
                data: simSEIRD.map(s => s.resZdrowi),  // Dane osi Y
                borderColor: 'rgba(75,192,91, 1)',  // Kolor linii
                backgroundColor: 'rgba(75,192,91, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
            {
                label: 'Chorzy',  // Legenda
                data: simSEIRD.map(s => s.resChorzy),  // Dane osi Y
                borderColor: 'rgb(192,75,75)',  // Kolor linii
                backgroundColor: 'rgba(192,75,75, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
            {
                label: 'Zakarzeni',  // Legenda
                data: simSEIRD.map(s => s.resZakazeni),  // Dane osi Y
                borderColor: 'rgb(163,75,192)',  // Kolor linii
                backgroundColor: 'rgba(163,75,192, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
            {
                label: 'Odporni',  // Legenda
                data: simSEIRD.map(s => s.resOdporni),  // Dane osi Y
                borderColor: 'rgb(75, 192, 192)',  // Kolor linii
                backgroundColor: 'rgba(75, 192, 192, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
            {
                label: 'Martwi',  // Legenda
                data: simSEIRD.map(s => s.resMartwi),  // Dane osi Y
                borderColor: 'rgb(0,0,0)',  // Kolor linii
                backgroundColor: 'rgba(0,0,0, 0.2)',  // Kolor tła
                tension: 0.1,  // Gładkość linii
            },
        ],
    };

    // Opcje wykresu (opcjonalne)
    const options = {
        responsive: true,  // Responsywność
        plugins: {
            legend: {
                display: true// Pozycja legendy
            },
        },
        /*scales: {
            x: {
                title: {
                    display: true,
                    text: "Time [h]",
                    align: 'end',
                    font: {
                        size: 16,
                        weight: 'bold',
                    },
                    padding: 0
                }
            }
        }*/
    };
    return (
        <>

            <Modelchoice>
                <ModelText>
                    Wybierz model:
                </ModelText>
                <RowForm>
                    <Label htmlFor="Model1">Model SIS</Label>
                    <InputRadioButton id="Model1" type="radio" name="model" value="SIS" onChange={handleChange} checked={ModelChoice==='SIS'}/>
                </RowForm>
                <RowForm>
                    <Label htmlFor="Model2">Model SIR</Label>
                    <InputRadioButton id="Model2" type="radio" name="model" value="SIR" onChange={handleChange} checked={ModelChoice==='SIR'}/>
                </RowForm>
                <RowForm>
                    <Label htmlFor="Model3">Model SEIRD</Label>
                    <InputRadioButton id="Model3" type="radio" name="model" value="SEIRD" onChange={handleChange} checked={ModelChoice==='SEIRD'}/>
                </RowForm>
            </Modelchoice>
            <ModelSIS display_options={(ModelChoice==='SIS').toString()}>
            <ContentContainer>
                <InputContainer>
                    <RowForm>
                        <Label htmlFor="N-SIS-input">Wprowadź liczebność populacji:</Label>
                        <Input id="N-SIS-input" name="N" model="SIS" type="number" defaultValue={inputsSIS.N} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="NI-SIS-input">Wprowadź liczbę osób zarażonych:</Label>
                        <Input id="NI-SIS-input" name="NI" model="SIS" type="number" defaultValue={inputsSIS.NI} onBlur={handleOutFocus} max="10000000000"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="t-SIS-input">Wprowadź długość symulacji:</Label>
                        <Input id="t-SIS-input" name="t" model="SIS" type="number" defaultValue={inputsSIS.t} onBlur={handleOutFocus} max="100" step={0.1}/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="lambda-SIS-input">Wprowadź współczynnik zaraźliwości:</Label>
                        <Input id="lambda-SIS-input" name="lambda" model="SIS" type="number" defaultValue={inputsSIS.lambda} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="mi-SIS-input">Wprowadź współczynnik urodzin/śmierci:</Label>
                        <Input id="mi-SIS-input" name="mi" model="SIS" type="number" defaultValue={inputsSIS.mi} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="gamma-SIS-input">Wprowadź współczynnik wyzdrowień:</Label>
                        <Input id="gamma-SIS-input" name="gamma" model="SIS" type="number" defaultValue={inputsSIS.gamma} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                </InputContainer>
                <ChartContainer>
                    <Line data={dataSIS} options={options} />
                </ChartContainer>
            </ContentContainer>
            </ModelSIS>
            <ModelSIR display_options={(ModelChoice==='SIR').toString()}>
            <ContentContainer>
                <InputContainer>
                    <RowForm>
                        <Label htmlFor="N-SIR-input">Wprowadź liczebność populacji:</Label>
                        <Input id="N-SIR-input" name="N" model="SIR" type="number" defaultValue={inputsSIR.N} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="NI-SIR-input">Wprowadź liczbę osób zarażonych:</Label>
                        <Input id="NI-SIR-input" name="NI" model="SIR" type="number" defaultValue={inputsSIR.NI} onBlur={handleOutFocus} max="10000000000"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="t-SIR-input">Wprowadź długość symulacji:</Label>
                        <Input id="t-SIR-input" name="t" model="SIR" type="number" defaultValue={inputsSIR.t} onBlur={handleOutFocus} max="100" step={0.1}/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="lambda-SIR-input">Wprowadź współczynnik zaraźliwości:</Label>
                        <Input id="lambda-SIR-input" name="lambda" model="SIR" type="number" defaultValue={inputsSIR.lambda} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="gamma-SIR-input">Wprowadź współczynnik wyzdrowień:</Label>
                        <Input id="gamma-SIR-input" name="gamma" model="SIR" type="number" defaultValue={inputsSIR.gamma} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                </InputContainer>
                <ChartContainer>
                    <Line data={dataSIR} options={options} />
                </ChartContainer>
            </ContentContainer>
            </ModelSIR>
            <ModelSEIRD display_options={(ModelChoice==='SEIRD').toString()}>
            <ContentContainer>
                <InputContainer>
                    <RowForm>
                        <Label htmlFor="N-SEIRD-input">Wprowadź liczebność populacji:</Label>
                        <Input id="N-SEIRD-input" name="N" model="SEIRD" type="number" defaultValue={inputsSEIRD.N} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="NE-SEIRD-input">Wprowadź liczbę zakażonych:</Label>
                        <Input id="NE-SEIRD-input" name="NE" model="SEIRD" type="number" defaultValue={inputsSEIRD.NE} onBlur={handleOutFocus} max="10000000000"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="t-SEIRD-input">Wprowadź długość symulacji:</Label>
                        <Input id="t-SEIRD-input" name="t" model="SEIRD" type="number" defaultValue={inputsSEIRD.t} onBlur={handleOutFocus} max="100" step={0.1}/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="beta-SEIRD-input">Wprowadź współczynnik prędkości przemiany:</Label>
                        <Input id="beta-SEIRD-input" name="beta" model="SEIRD" type="number" defaultValue={inputsSEIRD.beta} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="sigma-SEIRD-input">Wprowadź współczynnik zaraźliwość:</Label>
                        <Input id="sigma-SEIRD-input" name="sigma" model="SEIRD" type="number" defaultValue={inputsSEIRD.sigma} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="gamma-SEIRD-input">Wprowadź współczynnik wyzdrowień:</Label>
                        <Input id="gamma-SEIRD-input" name="gamma" model="SEIRD" type="number" defaultValue={inputsSEIRD.gamma} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                    <RowForm>
                        <Label htmlFor="delta-SEIRD-input">Wprowadź współczynnik śmiertelności:</Label>
                        <Input id="delta-SEIRD-input" name="delta" model="SEIRD" type="number" defaultValue={inputsSEIRD.delta} onBlur={handleOutFocus} min="1"/>
                    </RowForm>
                </InputContainer>
                <ChartContainer>
                    <Line data={dataSEIRD} options={options} />
                </ChartContainer>
            </ContentContainer>
            </ModelSEIRD>
        </>
    )
}

export default Zombie
